import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";
import { useSectionContent } from "@/hooks/useContent";

const STAT_LABELS = ["Anno di Fondazione", "Sede", "Motto", "Chilometri Percorsi"];

export default function About() {
  const c = useSectionContent("about");
  const stats = [c.stat1, c.stat2, c.stat3, c.stat4];

  return (
    <section id="chi-siamo" data-testid="about-section" className="py-24 sm:py-32 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <div>
          <SectionHeading
            overline={c.overline}
            title={c.title}
            testid="about-heading"
          />
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-6 space-y-5 text-sm sm:text-base text-[#C0B9B0] leading-relaxed"
          >
            <p>{c.text1}</p>
            <p>{c.text2}</p>
          </motion.div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {STAT_LABELS.map((label, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="leather-card p-7"
              data-testid={`about-stat-${i}`}
            >
              <p className="font-display text-2xl sm:text-3xl font-bold text-[#C5A059]">
                {stats[i]}
              </p>
              <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#78746D]">
                {label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
